export const yupValidator = async (callback, schema, values) => {
  try {
    await schema.validateSync(values);
    callback(false);
  } catch ({ errors }) {
    return callback(errors[0] ?? null);
  }
};
